import { Component } from "react";

import Header from "../components/Header/Header";
import Footer from "../components/Footer";
import { MainContainer } from "../components/UI/utils";
// import AuthFirebase from "../auth/authFirebaseDB";
import { Spinner } from "../components/UI/spinner";

class Layout extends Component {
    state = {
        currThemeType: "night",
        accessTokenAvailable: false,
    };

    // ! selected color theme type won't to store in localstore cos  selection of the color theme is based on the local time of the user
    async componentDidMount() {
        // AuthFirebase.init();
        // await AuthFirebase.generateFirebaseToken();
        this.setState({ accessTokenAvailable: true });

        const currTime = new Date().getHours() * 100 + new Date().getMinutes();

        if (2000 <= currTime && currTime < 800) this.themeHandler("night");
        if (800 <= currTime && currTime < 1200) this.themeHandler("morning");
        else if (1200 <= currTime && currTime < 2000)
            this.themeHandler("evening");
    }

    setThemeMetaTag = (setThemeColor) => {
        const metas = document.getElementsByTagName("meta");

        for (var i = 0; i < metas.length; i++) {
            if (
                metas[i].getAttribute("name") === "theme-color" ||
                metas[i].getAttribute("name") ===
                    "apple-mobile-web-app-status-bar-style"
            ) {
                metas[i].setAttribute("content", setThemeColor);
            }
        }
    };

    themeHandler = (newThemeType) => {
        if (!["night", "morning", "evening"].includes(newThemeType)) return;
        if (this.state.currThemeType === newThemeType) return;

        this.setState({ currThemeType: newThemeType });
        document.documentElement.setAttribute("data-theme", newThemeType);

        if (newThemeType === "night") this.setThemeMetaTag("#333333");
        else this.setThemeMetaTag("#ffffff");

        // TODO :: whenever user sets the theme than store that in localstore & also inform the user (that theme is stored as default) using snackbar
        // window.localStorage.setItem("theme", newThemeType);
    };

    render() {
        let sectionContent = <Spinner />;

        if (this.state.accessTokenAvailable)
            sectionContent = this.props.children;

        return (
            <div className="bg-primary-color min-w-screen min-h-screen box-border">
                <Header />
                <MainContainer>
                    {/* main page content */}
                    {sectionContent}
                </MainContainer>
                <Footer
                    currentThemeType={this.state.currThemeType}
                    toggleTheme={this.themeHandler}
                />
            </div>
        );
    }
}

export default Layout;
